import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { API_SETTINGS } from './API_SETTINGS';
import { Customer } from '../models/Customer';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'Customer';

@Injectable({
  providedIn: 'root'
})
export class ApiCustomerService {

  constructor(private http: HttpClient) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getCustomers(): Observable<any> {
    const url = apiUrl + '/GetCustomers';
    return this.http.get<any>(url).pipe();
  }

  getCustomerIdWithDomain(domain: string): Observable<number> {
    const url = apiUrl + '/GetCustomerIdWithDomain/' + domain;
    return this.http.get<number>(url).pipe();
  }

  getCustomerByCustomerId(id: number) {
    const url = `${apiUrl}/GetCustomerByCustomerId/${id}`;
    return this.http.get<Customer>(url).pipe();
  }

  updateCustomer(id: number, customer: any): Observable<Customer> {
    const url = `${apiUrl}/PutCustomer/${id}`;
    return this.http.put(url, customer, httpOptions).pipe(
      tap((ProjectRes: Customer) => true ), //console.log()),
      catchError(this.handleError<Customer>('updateCustomer'))
    )
  }

  addCustomer(customer: any): Observable<Customer> {
    const url = `${apiUrl}/AddCustomer`;
    return this.http.put(url, customer, httpOptions).pipe(
      tap((ProjectRes: Customer) => true ), //console.log()),
      catchError(this.handleError<Customer>('addCustomer'))
    )
  }

  deleteCustomer(id: number): Observable<any> {
    const url = `${apiUrl}/DeleteCustomer/${id}`;
    return this.http.put(url, null, httpOptions).pipe(
      tap((ProjectRes: Customer) => true ), //console.log()),
      catchError(this.handleError<Customer>('deleteCustomer'))
    )
  }
}
